import { IStatusbarItemDescriptor, IStatusbarRegistry, IStatusbarItemName } from '@workbench-stack/core';
import { Registry } from '@vscode-alt/monaco-editor/esm/vs/platform/registry/common/platform';
import { isArray } from '@vscode-alt/monaco-editor/esm/vs/base/common/types';
import { StatusbarExtensions } from '../constants';

const INPUT_DESCRIPTORS_PROPERTY = '__$itemDescriptors';

class StatusbarRegistry implements IStatusbarRegistry {
    private _items: IStatusbarItemDescriptor[];
    constructor() {
        this._items = [];
    }

    public getItems(): IStatusbarItemDescriptor[] {
        return this._items.slice();
    }

    public registerStatusbarItem(
        descriptor: IStatusbarItemDescriptor,
        itemDescriptor: IStatusbarItemName,
    ): void;
    public registerStatusbarItem(
        descriptor: IStatusbarItemDescriptor,
        itemDescriptor: IStatusbarItemName[],
    ): void;
    public registerStatusbarItem(
        descriptor: IStatusbarItemDescriptor,
        itemDescriptor: IStatusbarItemName | IStatusbarItemName[],
    ): void {
        // Support both non-array and array parameter
        let itemDescriptors: string[] = [];
        if (!isArray(itemDescriptor)) {
            itemDescriptors.push(itemDescriptor.__typename);
        } else {
            itemDescriptors = itemDescriptor.map(ed => ed.__typename);
        }

        descriptor[INPUT_DESCRIPTORS_PROPERTY] = itemDescriptors;
        this._items.push(descriptor);
    }

    public getItem(input: IStatusbarItemName): IStatusbarItemDescriptor | null {
        const findItemDescriptors = (i: IStatusbarItemName): IStatusbarItemDescriptor[] => {
            const matchingDescriptors: IStatusbarItemDescriptor[] = [];

            for (const item of this._items) {
                const inputDescriptors: string[] = item[INPUT_DESCRIPTORS_PROPERTY];
                for (const inputDescriptor of inputDescriptors) {
                    // Direct check
                    if (i.typeId) {
                        if (inputDescriptor === i.typeId) {
                            matchingDescriptors.push(item);
                            break;
                        }
                    }
                    // fallback to `__typename`
                    if (inputDescriptor === i.__typename) {
                        matchingDescriptors.push(item);
                        break;
                    }
                }
            }
            return matchingDescriptors;
        };
        const descriptors = findItemDescriptors(input);
        return descriptors[0];
    }
}

Registry.add(StatusbarExtensions.Statusbar, new StatusbarRegistry());
